import React from 'react';
import { Link } from "react-router-dom";
import { CookieSettingsTrigger } from '../CookieConsentProvider';
import { useLanguage } from '../../i18n';
import './Footer.css';

const Footer = () => {
  const { t, withLanguage } = useLanguage();

  return (
    <footer className="footer">
      {/* Bal oldali oszlop - ikonok */}
      <div className="socialicons">
        <a href="https://www.facebook.com/profile.php?id=61583882716651" target="_blank" rel="noopener noreferrer" className="icon">
          <img src="./images/facebook-svgrepo-com.svg" className="imgfacebook" alt="Facebook"/>
        </a>
        <a href="https://www.linkedin.com/company/fixanor" target="_blank" rel="noopener noreferrer" className="icon">
          <img src="./images/linkedin-1-svgrepo-com.svg" className="imglinkedin" alt="LinkedIn"/>
        </a>
        <a href="https://www.instagram.com/fixanor" target="_blank" rel="noopener noreferrer" className="icon">
          <img src="./images/instagram-svgrepo-com.svg" className="imginsta" alt="Instagram"/>
        </a>
        <a href="https://x.com/fixanor" target="_blank" rel="noopener noreferrer" className="icon">
          <img src="./images/twitter-x.svg" className="imgx" alt="X"/>
        </a>
      </div>

      {/* Középső oszlop - szöveg */}
      <div className="footerContent">
        <p className="text">&copy; 2025 Fixanor. {t("footer.rights")}</p>
        <div className="links">
          <Link to={withLanguage("/privacy-policy")} className="link">{t("common.privacyPolicy")}</Link>
          <span className="separator">|</span>
          <Link to={withLanguage("/impressum")} className="link">{t("footer.impressum")}</Link>
          <span className="separator">|</span>
          <CookieSettingsTrigger className="link">
            {t("common.cookieSettings")}
          </CookieSettingsTrigger>
        </div>
      </div>

      <div className="right"></div>
    </footer>
  );
};

export default Footer;
